import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { JsonApiResponse } from '../../shared/models/JsonApiResponse';
import { Storm, StormCreateRequest, StormShift } from '../../shared/models/storm.model';
import { environment } from '../../../environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { HttpErrorHandler } from '../../http.error.handler';

@Injectable({
  providedIn: 'root',
})
export class StormService {

  constructor(private http: HttpClient) { }

  createStorm(name: string, from: Date, to: Date) {
    const request = {
      name: name,
      startTime: from.toISOString(),
      endTime: to.toISOString(),
    } as StormCreateRequest;
    return firstValueFrom(
      this.http
        .post<JsonApiResponse<Storm>>(
          `${environment.services.service}v1/storm`,
          request,
        )
        .pipe(
          retry(3), // retry a failed request up to 3 times
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

  getStorm(stormId: number) {
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<Storm>>(
          `${environment.services.service}v1/storm/${stormId}`
        )
        .pipe(
          retry(3), // retry a failed request up to 3 times
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

  getStormAccess(stormId: number) {
    return firstValueFrom(
      this.http
        .get(
          `${environment.services.service}v1/storm/${stormId}/access`,
          {
            withCredentials: true, // needed to receive & store Set-Cookie from a cross-site response
            responseType: 'text',  // endpoint returns no body, just sets cookies — avoid JSON parse error
          }
        )
        .pipe(
          retry(3), // retry a failed request up to 3 times
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

  getStormShifts(stormId: number) {
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<StormShift[]>>(
          `${environment.services.service}v1/storm/${stormId}/shifts`
        )
        .pipe(
          retry(3), // retry a failed request up to 3 times
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }

  getStormPlaybackIndex(tenantId: number, stormId: number) {
    return firstValueFrom(
      this.http
        .get(
          `${environment.filesBaseUrl}storms/${tenantId}/${stormId}.location.index.json`,
          { withCredentials: true } // must send the cookies to files.*
        )
        .pipe(
          retry(3), // retry a failed request up to 3 times
          catchError(HttpErrorHandler.handleError) // then handle the error
        )
    );
  }
}
